module.exports = {"address":null,"city":null,"zipCode":null,"state":null,"unit":null,"residenceStatus":null}


//////////////////
// WEBPACK FOOTER
// ./src/components/profile/sections/tabs/contact/models/personalAddress.json
// module id = +Xcr
// module chunks = 1